import { render } from "./EndSaleArea.vue?vue&type=template&id=467f56a0&scoped=true"
import script from "./EndSaleArea.vue?vue&type=script&lang=js"
export * from "./EndSaleArea.vue?vue&type=script&lang=js"

import "./EndSaleArea.vue?vue&type=style&index=0&id=467f56a0&scoped=true&lang=css"

import exportComponent from "/Users/remy/Sites/baghera/WocUp/Front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-467f56a0"]])

export default __exports__